// extracted by mini-css-extract-plugin
export var divider = "_dw-7";
export var itemsToggle = "_dw-8";
export var mergeModal = "_dw-1";
export var optionCard = "_dw-4";
export var radioGroup = "_dw-6";
export var radioOption = "_dw-0";
export var selected = "_dw-5";
export var shipmentOptions = "_dw-2";
export var tableOptions = "_dw-3";